import React from 'react';
import PropTypes from 'prop-types';

// STYLES
import { Container } from './styles';

const KeyFeature = ({ data }) => {
  if (!Object.keys(data).length) return null;

  return (
    <Container className="key-feature" color={data.color}>
      {!!data.icon && <i className={`key-feature__icon icon-${data.icon}`} />}
      <p className="key-feature__title p5">{data.title}</p>
    </Container>
  );
};

KeyFeature.propTypes = {
  data: PropTypes.object.isRequired,
};

export default React.memo(KeyFeature);
